<template>
    <div>
        <div v-if="mainStore.module.base == 'MAXIRACE26'">
            <div class="d-flex flex-row ga-2">
                <SportipsButton :class="{ 'hidden': showFilters }" icon="mdi-filter" chevron
                    @click="showFilters = true">
                    Filtrer
                    les
                    préinscriptions
                </SportipsButton>
                <SportipsButton v-if="mainStore.authAdmin.hasSuperAdminRights" icon="mdi-currency-eur" chevron
                    toPage="ChargePendingsCommandes">
                    Encaisser
                </SportipsButton>
            </div>
            <v-row>
                <v-col v-if="showFilters" cols="12" :md="showFilters ? 3 : 0">
                    <TheFilters v-if="showFilters" @close="showFilters = false"></TheFilters>
                </v-col>
                <v-col cols="12" :md="showFilters ? 9 : 12">
                    <TheSummary>
                    </TheSummary>

                    <SportipsButton class="mb-2" @click="showConfirmationModal = true" chevron icon="mdi-check"
                        secondary-action-button
                        :disabled="preInscriptionMaxiraceStore.unique_id_commande_flagged.length == 0">
                        Valider les
                        préinscriptions
                        sélectionnées
                    </SportipsButton>

                    <TheList>
                    </TheList>

                </v-col>
            </v-row>

        </div>
        <v-dialog v-model="showConfirmationModal" max-width="800">
            <v-card>

                <v-card-text>
                    <p class="mb-3"><strong>Voulez-vous vraiment valider les préinscriptions sélectionnées ?</strong>
                    </p>

                    <div class="mb-4">
                        <div class="text-h6 font-weight-bold mb-2">📊 Récapitulatif des courses</div>
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th>Course</th>
                                    <th>Total</th>
                                    <th>Maximum</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="course in preInscriptionMaxiraceStore.validation_summary.courses"
                                    :key="course.nom" :class="{ 'bg-red-lighten-4': course.total > course.maximum }">
                                    <td>{{ course.nom }}</td>
                                    <td><strong>{{ course.total }}</strong></td>
                                    <td>{{ course.maximum }}</td>
                                    <td>
                                        <v-chip v-if="course.total > course.maximum" color="red" size="small"
                                            variant="flat">
                                            Dépassement
                                        </v-chip>
                                        <v-chip v-else-if="course.total === course.maximum" color="orange" size="small"
                                            variant="flat">
                                            Complet
                                        </v-chip>
                                        <v-chip v-else color="green" size="small" variant="flat">
                                            OK
                                        </v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </div>

                    <div v-if="preInscriptionMaxiraceStore.validation_summary.options.length > 0">
                        <div class="text-h6 font-weight-bold mb-2">🎟️ Récapitulatif des options</div>
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Total</th>
                                    <th>Maximum</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="option in preInscriptionMaxiraceStore.validation_summary.options"
                                    :key="option.nom"
                                    :class="{ 'bg-red-lighten-4': option.total > option.maximum && option.maximum > 0 }">
                                    <td>{{ option.nom }}</td>
                                    <td><strong>{{ option.total }}</strong></td>
                                    <td>{{ option.maximum > 0 ? option.maximum : 'Illimité' }}</td>
                                    <td>
                                        <v-chip v-if="option.maximum > 0 && option.total > option.maximum" color="red"
                                            size="small" variant="flat">
                                            Dépassement
                                        </v-chip>
                                        <v-chip v-else-if="option.maximum > 0 && option.total === option.maximum"
                                            color="orange" size="small" variant="flat">
                                            Complet
                                        </v-chip>
                                        <v-chip v-else color="green" size="small" variant="flat">
                                            OK
                                        </v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red-darken-4" variant="text" @click="showConfirmationModal = false">Annuler</v-btn>
                    <v-btn color="green-darken-4" variant="elevated"
                        @click="preInscriptionMaxiraceStore.markFlaggedAsValidated(); showConfirmationModal = false">
                        Confirmer la validation
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import TheFilters from "./TheFilters.vue";
import TheList from "./TheList.vue";
import TheSummary from "./TheSummary.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { usePreInscriptionMaxiraceStore } from "@/stores/specific/preInscriptionMaxirace";
export default {
    components: { TheFilters, TheList, TheSummary },
    computed: {
        ...mapStores(useMainStore),
        ...mapStores(usePreInscriptionMaxiraceStore),
    },
    data() {
        return {
            showFilters: false,
            showConfirmationModal: false,
        }
    },
    methods: {

    },
    async mounted() {
        await this.preInscriptionMaxiraceStore.loadCourses(this.mainStore.module.id);
        await this.preInscriptionMaxiraceStore.loadOptions(this.mainStore.module.id);
        await this.preInscriptionMaxiraceStore.initFilters();
        await this.preInscriptionMaxiraceStore.search();

    },

}
</script>

<style lang="scss" scoped>
.hidden {
    visibility: hidden;
}
</style>